import '../css/reset.css';
import '../css/whatever.css';

import FastClick from 'c-fastclick';
import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';
import lang from './lang/index';
import url from 'c-url';

import Verify from './view/verify';
import ResetPassword from './view/reset-password';

FastClick.attach(document.body);

class App extends Component {

	render() {
		//return <Verify />;
		let pageType = url.query('type');
		return pageType == 'verify' ? <Verify /> : pageType == 'resetpwd' ? <ResetPassword /> : null;
	}
}

render(<App />, $('#wrap')[0]); 



// WEBPACK FOOTER //
// ./js/app.js